import Router from './routes';
import ThemeProvider from './theme';
import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import ThemeColorPresets from './components/ThemeColorPresets';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import UrbiaLoading from './components/UrbiaLoading';
import { useSelector } from './redux/store';
import ReactPixel from 'react-facebook-pixel';

export default function App() {
  const { isLoading } = useSelector((state) => state.loading);
  ReactPixel.init('1299019917652687');

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ScrollToTop />
              {isLoading ?  <UrbiaLoading/> : <Router />}
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
